<bizz-modal modalSize="xs" [title]="'FoundCertificates'"
            [contentTemplate]="contentTemplateRef" [footerTemplate]="footerTemplateRef"></bizz-modal>

<ng-template #contentTemplateRef>
    <div class="modal-header">
        <bizz-alert type="warning" align="left" [message]="replace('ResultCheckDuplicateWarning' | translate)" ></bizz-alert>
    </div>
</ng-template>

<ng-template #footerTemplateRef>
    <div class="grid grid-cols-12 gap-3 w-full">
        <button class="default col-span-2" (click)="dialogRef.close()"> <span class="m-auto">{{ 'Cancel' | translate }}</span></button>
        <button class="default col-span-5" (click)="dialogRef.close()"> <span class="m-auto">{{ 'KeepUploaded' | translate }}</span></button>
        <button class="default col-span-5" (click)="dialogRef.close(true)"> <span class="m-auto">{{ 'YesReplaceAll' | translate }}</span></button>
    </div>
</ng-template>